import { IMedicalPrescriptionMappingConfiguration } from "./imedical-prescription-mapping-configuration";
import { ProductCategory } from "./product-category";
import { MedicalPrescriptionMappingType } from "./medical-prescription-mapping-type";
import { MedicalPrescriptionValidity } from "./medical-prescription-validity";

export class MedicalPrescriptionMappingConfiguration implements IMedicalPrescriptionMappingConfiguration {
  private productCategory: ProductCategory;
  private medicalPrescriptionValidity: MedicalPrescriptionValidity;
  private validDaysPeriod: number;
  private type: MedicalPrescriptionMappingType;

  setProductCategory(value: ProductCategory): void {
    this.productCategory = value;
  }

  getProductCategory(): ProductCategory {
    return this.productCategory;
  }

  setMedicalPrescriptionValidity(value: MedicalPrescriptionValidity): void {
    this.medicalPrescriptionValidity = value;
  }

  getMedicalPrescriptionValidity(): MedicalPrescriptionValidity {
    return this.medicalPrescriptionValidity;
  }

  setValidDaysPeriod(value: number): void {
    this.validDaysPeriod = value;
  }

  getValidDaysPeriod(): number {
    return this.validDaysPeriod;
  }

  setType(value: MedicalPrescriptionMappingType): void {
    this.type = value;
  }

  getType(): MedicalPrescriptionMappingType {
    return this.type;
  }
}
